<template>
  <div class="authenticated-layout">
    <pager-header class="header" />
    <side-bar
      class="side-bar"
      :class="!getSidebarIsOpen ? 'not-is-open' : ''"
    />
    <basic-modal
      v-if="basicModal !== undefined"
      :showModal="basicModal !== undefined"
      :title="basicModal.title"
      :description="basicModal.description"
      :okButton="basicModal.okButton"
      :textAlign="basicModal.textAlign"
      :cancelButton="basicModal.cancelButton"
    />
    <confirm-modal
      v-if="confirmModal !== undefined"
      :showModal="confirmModal !== undefined"
      :title="confirmModal.title"
      :subTitle="confirmModal.subTitle"
      :userId="confirmModal.userId"
      @okButtonClicked="handleConfirmModalOkButton"
      @cancelButtonClicked="handleConfirmModalCancelButton"
    />
    <component-bind-modal
      v-if="componentModalContent"
      :component="componentModalContent"
    />
    <popper
      v-if="popperContent"
      :component="popperContent"
      :headerTitle="popperTitle"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SideBar from "@/components/global/sideBar/SideBar";
import PagerHeader from "@/components/global/PagerHeader/PagerHeader";
import BasicModal from "@/components/global/modalComponents/basicModal/BasicModal";
import ConfirmModal from "@/components/global/modalComponents/confirmDeleteModal/ConfirmDeleteModal";
import ComponentBindModal from "@/components/global/modalComponents/componentBindModal/ComponentBindModal";
import Popper from "@/components/global/popperComponents/Popper";

export default {
  name: "AuthenticatedLayout",
  components: {
    SideBar,
    PagerHeader,
    BasicModal,
    ConfirmModal,
    ComponentBindModal,
    Popper,
  },
  data() {
    return {
      confirmModal: undefined,
      basicModal: undefined,
      componentModalContent: undefined,
      popperContent: undefined,
      popperTitle: undefined,

      activeConfirmModal: false,
    };
  },
  mounted() {
    this.emitter.on("showBasicModal", (payload) => {
      this.basicModal = payload;
    });
    this.emitter.on("showConfirmModal", (payload) => {
      this.confirmModal = payload;
      this.activeConfirmModal = true;
    });
    this.emitter.on("closeConfirmModal", () => {
      this.confirmModal = undefined;
      this.activeConfirmModal = false;
    });
    this.emitter.on("showComponentModalModal", (payload) => {
      this.componentModalContent = payload;
    });
    this.emitter.on("showPopper", (payload) => {
      this.popperContent = payload;
      this.popperTitle = payload.bind.headerTitle;
    });
    this.emitter.on("closeModal", () => {
      if (!this.activeConfirmModal) {
        this.componentModalContent = undefined;
        this.basicModal = undefined;
      } else if (this.activeConfirmModal) {
        this.emitter.emit("closeConfirmModal");
      }
    });
    this.emitter.on("closePopper", () => {
      if (!this.activeConfirmModal) {
        this.popperContent = undefined;
        this.popperTitle = undefined;
      } else if (this.activeConfirmModal) {
        this.emitter.emit("closeConfirmModal");
      }
    });
    document.addEventListener("keyup", (e) => {
      if (e.key == "Escape" && !this.activeConfirmModal) {
        (this.basicModal = undefined),
          (this.componentModalContent = undefined),
          (this.popperContent = undefined);
      } else if (e.key == "Escape" && this.activeConfirmModal) {
        this.emitter.emit("closeConfirmModal");
      }
    });
  },
  computed: {
    ...mapGetters({
      getSidebarIsOpen: "siteSettings/sidebarIsOpen",
    }),
  },
};
</script>

<style lang="scss" scoped>
.side-bar {
  transition: all 0.4s;
  position: fixed;
  left: 0;
  top: 0;
  width: 224px;
  z-index: 2;
  height: 100%;
  &.not-is-open {
    width: 0px;
  }
}
@media(max-width: 620px) {
  .side-bar {
    width: 100%;
  }
}
.header {
  position: relative;
}
</style>
